/* eslint-disable max-len */
const stepsLink = 'https://help.playbookux.com/en/articles/5992427-granting-screen-share-audio-and-video-permissions-before-a-moderated-session';
const faqLink = 'https://help.playbookux.com/en/articles/4430929-moderated-interview-faqs';

const description = `
    Please read before your session:\n
    We suggest that you use Chrome, Firefox, Brave or Edge. At the moment, Safari does not allow you to share your screen. Note: participants will still be able to share their screen regardless of the browser you use.\n
    If this is your first time testing with us, please take a moment to grant permission to your microphone, video camera and screen recording before the session to ensure a smooth testing experience.\n
    Steps to grant permission ${stepsLink}\n
    More information on no-shows, reschedules and other FAQs ${faqLink}\n
`;

export default description;
